import { TreeItem2, TreeItem2Content, TreeItemProps, TreeItemSlotProps } from '@mui/x-tree-view';
import React from 'react';
import { IconLabel, IconLabelProps } from 'components/treeselect/IconLabel';
import { CustomCheckbox } from 'components/treeselect/CustomCheckbox';
import { useTreeItem2 } from '@mui/x-tree-view/useTreeItem2/useTreeItem2';
import { tbColors } from 'styles/colors';

const TreeSelectItemContent = React.forwardRef<HTMLDivElement, React.ComponentProps<typeof TreeItem2Content>>(
  function TreeSelectItemContent({ sx, ...props }, ref) {
    return (
      <TreeItem2Content
        // MUI slot props must be forwarded to preserve TreeView event handling.
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        ref={ref}
        sx={{
          paddingTop: 0,
          paddingBottom: 0,
          backgroundColor: 'transparent !important',
          '&.Mui-selected, &.Mui-focused.Mui-selected': {
            backgroundColor: `${tbColors.all.snow[200]} !important`,
          },
          '&:hover, &.Mui-selected:hover, &.Mui-focused:hover': {
            backgroundColor: `${tbColors.all.snow[100]} !important`,
          },
          ...sx,
        }}
      />
    );
  }
);

export interface TreeItemWithIcon {
  id: string;
  label: string;
  icon?: React.ReactElement;
  visible?: boolean;
  indeterminate?: boolean;
  children?: TreeItemWithIcon[];
  parent?: TreeItemWithIcon;
}

export const CustomTreeItem = React.memo(
  React.forwardRef<HTMLLIElement, TreeItemProps>((props, ref) => {
    const { id, itemId, label, disabled, children } = props;

    const { publicAPI } = useTreeItem2({ id, itemId, children, label, disabled, rootRef: ref });

    const item = publicAPI.getItem(itemId) as TreeItemWithIcon;

    return (
      <TreeItem2
        itemId={itemId}
        label={label}
        hidden={!item.visible}
        ref={ref}
        slots={{
          content: TreeSelectItemContent,
          label: IconLabel,
          checkbox: CustomCheckbox,
        }}
        slotProps={
          {
            content: { 'data-testid': `tree-select-item-${itemId}` },
            checkbox: { item },
            label: { icon: item?.icon } as IconLabelProps,
          } as TreeItemSlotProps
        }
      >
        {children}
      </TreeItem2>
    );
  })
);
